<template>
  <common-swipper heading="News & Media" sub-heading="Recognized by leading business publications and industry voices."
    :items="newsListToShow" :CardComponent="CommonNewsCard" :isLoading="isLoading" />
</template>

<script setup>
import { ref, onMounted } from "vue";
import { CommonNewsCard } from "#components";
import pressReleaseService from "~/service/pressReleaseService";

// Static fallback list
// const newsList = [
//   {
//     image: "https://picsum.photos/id/1015/600/300",
//     createdAt: "2025-09-24",
//     heading: "Big Update in Finance Industry",
//   },
//   {
//     image: "https://picsum.photos/id/1025/600/300",
//     createdAt: "2025-09-23",
//     heading: "Stock Market Gains Momentum",
//   },
//   {
//     image: "https://picsum.photos/id/1035/600/300",
//     createdAt: "2025-09-22",
//     heading: "New Investment Opportunities",
//   },
//   {
//     image: "https://picsum.photos/id/1045/600/300",
//     createdAt: "2025-09-21",
//     heading: "Policy Changes Announced",
//   },
// ];

// const newsListToShow = ref([...newsList]); // start with static list
const newsListToShow = ref([]); // start with static list
const isLoading = ref(true);

onMounted(async () => {
  try {
    const response = await pressReleaseService.getAllPressReleases("page=1&limit=20&isDeleted=false");
    const list = response?.data ?? (Array.isArray(response) ? response : []);
    if (list.length) {
      newsListToShow.value = list.map((item) => ({
        image: item.image || "",
        heading: item.title || "",
        createdAt: item.publishDate || new Date(item.createdAt).toISOString().split("T")[0],
        src: item.titleUrl ? `/resources/news/${item.titleUrl}` : "",
      }));
    }
  } catch (error) {
    console.error("Failed to fetch press releases:", error);
  } finally {
    isLoading.value = false;
  }
});
</script>

<style scoped>
.products-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content {
  margin-top: 30px;
  width: 100%;
}

:deep(.swiper) {
  width: 100%;
  padding-top: 20px;
  padding-bottom: 40px;
}

:deep(.swiper-slide) {
  display: flex;
  justify-content: center;
}
</style>
